module.exports = __webpack_public_path__ + "static/media/big_sur.0063ab76.jpeg";